import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "./integrations/supabase/auth-attacher";

// SDE.4 · Onda 4.2 — Middleware de captura APM em torno do errorMiddleware.
// Preserva o comportamento pré-existente: qualquer HTTPResponse-shaped error
// segue seu curso; erros "puros" viram HTML 500. A captura é fire-and-forget
// e no-op quando a flag `apm_enabled_server` está desligada (ou o adapter
// não foi registrado). Não altera latência do caminho feliz.
const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    // Fire-and-forget APM capture — nunca await, nunca lança.
    void import("./lib/apm")
      .then((m) => m.captureError(error, { scope: "server" }))
      .catch(() => {});
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware],
  functionMiddleware: [attachSupabaseAuth],
}));
